import { render, staticRenderFns } from "./PerguntaForm.vue?vue&type=template&id=2948233f&scoped=true&"
import script from "./PerguntaForm.vue?vue&type=script&lang=js&"
export * from "./PerguntaForm.vue?vue&type=script&lang=js&"
import style0 from "./PerguntaForm.vue?vue&type=style&index=0&id=2948233f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948233f",
  null
  
)

export default component.exports